import React, { Component, MouseEvent } from "react";
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";

import type Project from "../../models/Project";

type OwnProps = {
  project: Project,
  facade: JSX.Element,
  handleEditClick: (event: MouseEvent, project: Project) => void,
  handleDeleteClick: (event: MouseEvent, project: Project) => void,
  handleDuplicateClick: (event: MouseEvent, project: Project) => void,
  direction: string,
  canAddProject: boolean,
  isOwner: boolean,
};

type State = {
  isOpen: boolean,
};

class OptsDropdown extends Component {
  props: Props;
  state: State = {
    isOpen: false,
  };

  constructor(props: Props) {
    super(props);
  }

  componentDidMount() {
    if (this.props.isLoggedIn) {
      this.loadProjectsPromise = Promise.resolve(this.props.loadProjects());
    }
  }

  toggleOpen = (event: MouseEvent) => {
    event.stopPropagation();
    this.setState({ isOpen: !this.state.isOpen });
  };

  render() {
    return this.props.isOwner ? (
      <Dropdown
        className="project-opts-dropdown menu-button-container"
        isOpen={this.state.isOpen}
        toggle={this.toggleOpen}
        direction={this.props.direction}
      >
        <DropdownToggle
          className="d-inline-block menu-button"
          tag="span"
          data-toggle="dropdown"
        >
          {this.props.facade}
        </DropdownToggle>
        <DropdownMenu>
          <div>
            {this.props.accountExpired ? (
              <div style={{ padding: "4px 12px" }}>Account expired</div>
            ) : (
              <div>
                <div
                  className="dropdown-menu-item"
                  onClick={(event: MouseEvent) => {
                    this.props.handleEditClick(event);
                    this.toggleOpen(event);
                  }}
                >
                  <i className="fa fa-pencil"></i>
                  <span>Edit</span>
                </div>
                <div
                  className="dropdown-menu-item"
                  onClick={(event: MouseEvent) => {
                    this.props.handleDeleteClick(event);
                    this.toggleOpen(event);
                  }}
                >
                  <i className="fa fa-trash"></i>
                  <span>Delete</span>
                </div>
                {this.props.canAddProject && (
                  <div
                    className="dropdown-menu-item"
                    onClick={(event: MouseEvent) => {
                      this.props.handleDuplicateClick(event);
                      this.toggleOpen(event);
                    }}
                  >
                    <i className="fa fa-copy"></i>
                    <span>Duplicate</span>
                  </div>
                )}
              </div>
            )}
          </div>
        </DropdownMenu>
      </Dropdown>
    ) : (
      <div
        style={{
          fontSize: 11,
          width: 60,
          // Not sure if this width 60 is all that safe in different environments
          // because of the width calculation for the previous cell.
        }}
      >
        As Guest
      </div>
    );
  }
}

export default OptsDropdown;



// WEBPACK FOOTER //
// ./src/views/user/projects/OptsDropdown.js